import type { User } from '@auth0/auth0-react'
import { addDays, isAfter } from 'date-fns'
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'

import useSiteMetadata from '../../../hooks/useSiteMetadata'
import { useAuth } from '../../../lib/auth'
import { isUserCategory, UserCategory, userClaimIds } from '../../../utils/userClaims'
import CommissionsNotification from '../../shop/account/commissions/CommissionsNotification'

export const SubmitPractitionerFormsReminder: FC = () => {
  const [showCommissions, setShowCommissions] = useState(false)
  const { featureFlags } = useSiteMetadata() ?? {}
  const { user } = useAuth()
  const createdAt = user ? user[userClaimIds.createdAt] : undefined

  const parseUserCategory = useCallback(
    (userToParse: User | undefined): UserCategory | undefined => {
      const userCategory = userToParse ? (userToParse[userClaimIds.category] as unknown) : undefined
      return isUserCategory(userCategory) ? userCategory : undefined
    },
    [],
  )

  const userCategory = useMemo(() => parseUserCategory(user), [parseUserCategory, user])

  useEffect(() => {
    if (userCategory === 'practitioner' && featureFlags?.practitionerFormsReminder && createdAt) {
      const twentyFourHoursLater = addDays(new Date(createdAt), 1)
      const currentDate = new Date()
      const shouldShow = isAfter(currentDate, twentyFourHoursLater)
      setShowCommissions(shouldShow)
    }
  }, [userCategory, featureFlags, createdAt])

  return showCommissions ? <CommissionsNotification /> : null
}
